import React, {useEffect} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import EncryptionDecryption from '../util/encrption';
import login from '../assets/images/login.png';
import '../assets/styles/global.css';
import LoginBlock from '../component/loginContainer'


const defaultTheme = createTheme();

export default function SignIn() {

    // parameter parsing
    const parseDecryptedString = (decryptedString) => {
        const params = {};
        if (decryptedString) {
            const pairs = decryptedString.split('&');
            pairs.forEach(pair => {
                const [key, value] = pair.split('=');
                // if (key && value) {
                    params[key] = value;
                // }
            });
        }
        return params;
    };

    useEffect(() => {
        var EncryptedURL = window.location.href;
        if(EncryptedURL !== null){
            try {
                const decrypted = EncryptionDecryption(EncryptedURL);
                if (decrypted.length > 0) {
                    const params = parseDecryptedString(decrypted);
                    const userId = params.UserId || 0;
                    const source = params.Source || '';
                    const ppUserId = params.PPUserId || 0;
                    
                    sessionStorage.setItem('userId', userId);
                    sessionStorage.setItem('umsSourceName', source);
                    sessionStorage.setItem('ppUserId', ppUserId);
                } else {
                    sessionStorage.setItem('userId', 0);
                    sessionStorage.setItem('umsSourceName', '');
                    sessionStorage.setItem('ppUserId', 0);
                }
            } catch (e) {
                sessionStorage.setItem('userId', 0);
                sessionStorage.setItem('umsSourceName', '');
                sessionStorage.setItem('ppUserId', 0);
            }
        } else {
            console.log('URL parameter "data" is null or undefined');
        }
        
    }, []);

    return (
        <ThemeProvider theme={defaultTheme}>
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={6}
                sx={{
                backgroundImage: `url(${login})`,
                backgroundRepeat: 'no-repeat',
                backgroundColor: (t) =>
                  t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                backgroundSize: 'cover',
                backgroundPosition: 'center',

                }}
            />
            <LoginBlock display={'flex'} justifyContent={"center"} alignItems={"center"}/>
            
           
        </Grid> 
        </ThemeProvider>
    );
}